import { z } from 'zod';
import { ErrorCodeSchema } from './errors.js';
import { PlanTierSchema, QuotaStateValueSchema, StatusResponseDataSchema, UsageResponseDataSchema, } from './billing.js';
export const ApiQuotaMetaSchema = z.object({
    remaining: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
    overageEnabled: z.boolean().optional(),
    quotaState: QuotaStateValueSchema.optional(),
});
export const ApiRateLimitMetaSchema = z.object({
    remaining: z.number().int(),
    reset: z.number().int().nonnegative(),
});
export const ApiPaginationMetaSchema = z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
});
export const ApiMetaSchema = z.object({
    requestId: z.string(),
    timestamp: z.string().datetime(),
    rateLimit: ApiRateLimitMetaSchema.optional(),
    quota: ApiQuotaMetaSchema.optional(),
    pagination: ApiPaginationMetaSchema.optional(),
});
export const ApiSuccessEnvelopeSchema = z.object({
    ok: z.literal(true),
    data: z.unknown(),
    requestId: z.string().optional(),
    meta: ApiMetaSchema.optional(),
});
export const ActionableSuggestionSchema = z.object({
    // Always present — the cycle renewal date is useful to every tier.
    cycleResetDate: z.string().datetime(),
    // Present ONLY when a real upgrade exists. A top-tier (power) customer at
    // their overage ceiling has nowhere to upgrade, so these are omitted and the
    // client shows a renewal-only message instead of a CTA to the plan they're
    // already on.
    upgradeUrl: z.string().url().optional(),
    recommendedPlan: PlanTierSchema.optional(),
});
export const ApiErrorEnvelopeSchema = z.object({
    ok: z.literal(false),
    error: z.object({
        code: ErrorCodeSchema,
        message: z.string(),
        suggestion: z.string().optional(),
        actionableSuggestion: ActionableSuggestionSchema.optional(),
        retryAfter: z.number().int().positive().optional(),
    }),
    requestId: z.string().optional(),
    meta: ApiMetaSchema.optional(),
});
export const StatusSuccessEnvelopeSchema = z.object({
    ...ApiSuccessEnvelopeSchema.shape,
    data: StatusResponseDataSchema,
});
export const StatusEnvelopeSchema = z.union([
    StatusSuccessEnvelopeSchema,
    z.object({
        data: StatusResponseDataSchema,
    }),
]);
export const UsageSuccessEnvelopeSchema = z.object({
    ...ApiSuccessEnvelopeSchema.shape,
    data: UsageResponseDataSchema,
});
export const UsageEnvelopeSchema = z.union([
    UsageSuccessEnvelopeSchema,
    z.object({
        data: UsageResponseDataSchema,
    }),
]);
//# sourceMappingURL=api-envelope.js.map